<template>
    <footer
        class="fixed z-30 bg-theme-canvas bottom-0 w-full border-t border-theme-border backdrop-blur-sm"
    >
        <div
            class="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 text-xs text-theme-muted"
        >
            <div class="flex items-center gap-2 min-w-0">
                <router-link
                    to="/app"
                    aria-label="Ir a inicio"
                    class="text-theme-muted hover:text-theme-base transition flex-shrink-0"
                >
                    <HomeIcon class="w-4 h-4" />
                </router-link>

                <template v-if="$publicUrl">
                    <a
                        :href="$publicUrl"
                        target="_blank"
                        rel="noopener"
                        class="inline-flex items-center gap-1.5 no-underline text-theme-muted hover:text-theme-base transition min-w-0"
                        :title="$publicUrl"
                    >
                        <span class="relative flex h-2 w-2 flex-shrink-0">
                            <span
                                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-theme-success opacity-75"
                            ></span>
                            <span
                                class="relative inline-flex rounded-full h-2 w-2 bg-theme-success"
                            ></span>
                        </span>
                        <span class="truncate">
                            {{ catalogLabel }}
                        </span>
                        <ExternalLinkIcon
                            class="w-3 h-3 flex-shrink-0 opacity-60"
                        />
                    </a>
                </template>
                <span v-else class="select-none">
                    © {{ new Date().getFullYear() }} {{ $siteTitle }}
                </span>
            </div>

            <div class="flex items-center gap-2 flex-shrink-0">
                <span class="font-mono text-2.75 hidden sm:inline">
                    v{{ $siteVersion }}
                </span>
                <change-theme />
            </div>
        </div>
    </footer>
</template>

<script>
import { MARKETPLACE_PORTAL_URL } from "@/common/constants";
import { stripUrlProtocol } from "@/common/lib/url";

import ExternalLinkIcon from "@/components/icons/ExternalLinkIcon.vue";
import HomeIcon from "@/components/icons/HomeIcon.vue";
import ChangeTheme from "@/components/layout/ChangeTheme.vue";

export default {
    components: {
        ChangeTheme,
        ExternalLinkIcon,
        HomeIcon
    },
    props: {
        additionalClass: {
            type: String,
            default: () => ""
        }
    },
    data: () => ({
        $siteUrl: MARKETPLACE_PORTAL_URL
    }),
    computed: {
        catalogLabel() {
            return stripUrlProtocol(this.$publicUrl);
        }
    }
};
</script>
